import React from 'react'
import s from './StatusMessage.less'
import classnames from 'classnames'

const StatusMessage = ({ message, visible = false, className }) => {
  return (
    <div className={classnames(s.status, visible && s.statusVisible, className)}>
      <span className={s.statusText}>{message}</span>
    </div>
  )
}

export default StatusMessage
